import product1 from "./firefly/firefly.webp";
import product1Img1 from "./firefly/img1.jpg";
import product1Img2 from "./firefly/img2.png";
import product1Img3 from "./firefly/img3.jpg";

import product2 from "./S360/S360.png";
import product2Img1 from "./S360/img1.png";
import product2Img2 from "./S360/img2.jpg";
export const EyefficientProducts = [
  {
    id: 1,
    name: 'S390L Firefly Digital Slit Lamp Imaging System',
    title: "S390L Firefly Digital Slit Lamp Imaging System",
    features: {
      feature1: "Captures high-resolution images for detailed diagnosis and documentation",
      feature2: "Offers advanced imaging capabilities, including meibography and fluorescein imaging",
      feature3: "Enhances clinical efficiency with automated functions and user-friendly interface",
      feature4: "Facilitates patient education and communication through clear image sharing"
    },
    images: {
      product1Img1,
      product1Img2,
      product1Img3,
    },
    image: product1,
    description: "Streamline workflows, capture vivid details for faster diagnoses, and elevate patient care with exceptional technology.",
    link: "https://www.mediworks.biz/en/product/opthalmic-slit-lamp-microscope-s390l"
  },
  {
  id: 2,
  name: 'S360 Slit Lamp',
  title: "S360 Slit Lamp",
  features: {
    feature1: "Provides high-quality optics for clear and detailed examination of the anterior segment.",
    feature2: "Offers smooth and precise joystick control for accurate patient positioning.",
    feature3: "Equipped with a durable and ergonomic design to withstand heavy clinical use.",
    feature4: "Compatible with digital imaging systems for enhanced diagnostic capabilities."
  },
  images: {
    product2Img1,  // Placeholder for additional image variables
    product2Img2,
  },
  image: product2,  // Placeholder for the main image variable
  description: "Experience the precision and durability of the S360 Slit Lamp, designed for detailed anterior segment examination.",
  link: "https://www.eyefficient.com/slit-lamps/converging-optics"
}

  // ... more products
];
